import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeEnergy: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHomeEnergy"><Path d="M2 9.74994L12 2.44873L22 9.74994M19.5 10.4623L19.5 8.25M12.5 20.4999H4.50001V8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Path d="M19.5 13L15 18.5H17.5V22L22 16.5H19.5V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeEnergy;
